export default "__VITE_ASSET__499c8a6a__"